// extracted by mini-css-extract-plugin
export default {"container":"Ounyu","openedContainer":"YyQfB","closeButton":"bUHnV"};